<template>
  <div
    class="relative "
    :class="{
      'w-full': isMobile() && showSidebarOnMobile,
      ' lg:flex flex-col  w-full max-w-xs flex-grow flex-shrink-0 border-l bg-gray-100 overflow-y-auto relative z-10': !isMobile()
    }"
  >
    <button
      v-if="isMobile() && !showSidebarOnMobile"
      @click="toggleSidebar"
      class="absolute z-50 top-15 right-0 bg-indigo-500 rounded-l-md  text-white p-2"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M11 19l-7-7 7-7m8 14l-7-7 7-7"
        />
      </svg>
    </button>
    <div
      class=" lg:flex flex-col  w-full max-w-xs flex-grow flex-shrink-0 border-l bg-gray-100 overflow-y-auto"
      :class="{
        'absolute z-50': isMobile() && showSidebarOnMobile,
        'relative z-10': !isMobile(),
        hidden: isMobile() && !showSidebarOnMobile
      }"
    >
      <div>
        <div
          class="  w-full justify-center items-center overflow-hidden  rounded-lg  mx-auto"
        >
          <div
            class="flex justify-end"
            v-if="isMobile() && showSidebarOnMobile"
            @click="toggleSidebar"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
          <div class="relative h-4"></div>
          <div class="flex justify-center">
            <div
              class="flex items-center justify-center  bg-indigo-500 flex-shrink-0 text-white rounded-full  shadow border-4 border-white  h-24 w-24 "
            >
              {{ getFirstCharacter() }}
            </div>
          </div>
          <div class="mt-4" v-if="conversation.customer">
            <h1
              class="text-lg font-inter leading-loose text-center font-medium text-gray-600"
            >
              {{ conversation.customer.firstName }}
              {{ conversation.customer.lastName }}
            </h1>
            <p
              class="text-xs font-inter leading-normal text-center font-medium text-cool-gray-500 uppercase"
            >
              {{ conversation.customer.phoneNumber }}
            </p>
          </div>
          <div v-if="isLoading" class="text-center mt-2 text-sm">
            Loading....
          </div>
          <div
            v-if="!isLoading && customer && Object.keys(customer).length > 0"
          >
            <div class="flex justify-center mt-4" v-if="customer">
              <div class="flex flex-col mx-4">
                <h3
                  class="text-xs font-inter leading-normal text-center font-medium text-cool-gray-600 uppercase"
                >
                  lifetime value
                </h3>
                <span
                  class="font-inter text-center font-medium text-cool-gray-500 uppercase my-4"
                >
                  {{ customer.lifetimeVal }}</span
                >
              </div>
              <div class="flex flex-col mx-4">
                <h3
                  class="text-xs font-inter leading-normal text-center font-medium text-cool-gray-600 uppercase"
                >
                  Customer since
                </h3>
                <span
                  class="font-inter text-center font-medium text-cool-gray-500 my-4"
                  >{{ customer.createdAt }}</span
                >
              </div>
            </div>
            <div>
              <div class="px-2">
                <input
                  type="text"
                  v-model="productSearchText"
                  placeholder="search products"
                  @input="searchProducts"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md border p-2 "
                />
              </div>
              <ul
                v-if="products.length > 0"
                class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                tabindex="-1"
                role="listbox"
                aria-labelledby="listbox-label"
                aria-activedescendant="listbox-option-3"
              >
                <!--
        Select option, manage highlight styles based on mouseenter/mouseleave and keyboard navigation.

        Highlighted: "text-white bg-indigo-600", Not Highlighted: "text-gray-900"
      -->
                <li
                  class="text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9"
                  id="listbox-option-0"
                  role="option"
                  v-for="(product, index) of products"
                  :key="index"
                >
                  <div class="flex items-center">
                    <img
                      :src="product.image"
                      alt=""
                      class="flex-shrink-0 h-6 w-6 rounded-full"
                    />
                    <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
                    <span class="font-normal ml-3 block truncate">
                      {{ product.title }}
                    </span>
                  </div>

                  <!--
          Checkmark, only display for selected option.

          Highlighted: "text-white", Not Highlighted: "text-indigo-600"
        -->
                  <span
                    class="text-indigo-600 absolute inset-y-0 right-0 flex items-center pr-4 cursor-pointer"
                    @click="sendProductLinkToChat(product)"
                  >
                    <!-- Heroicon name: solid/check -->
                    Send to chat
                  </span>
                </li>

                <!-- More items... -->
              </ul>
            </div>

            <div class="mt-4  " v-if="customer.defaultAddress">
              <h2
                class="text-xs font-inter leading-normal text-center font-medium text-cool-gray-600 uppercase"
              >
                default address
              </h2>
              <p
                class="text-xs font-inter leading-normal text-cool-gray-500 px-2 py-2"
              >
                {{ customer.defaultAddress.first_name }}
                {{ customer.defaultAddress.last_name }}
                <br />
                {{ customer.defaultAddress.address1 }}
                <br />
                {{ customer.defaultAddress.address2 }}
                <br />
                {{ customer.defaultAddress.zip }}
                {{ customer.defaultAddress.city }}
                {{ customer.defaultAddress.province }}
                <br />
                {{ customer.defaultAddress.country_name }}
                <br />
              </p>
            </div>

            <div class="" v-if="customer && Object.keys(customer).length > 0">
              <h2
                class="text-xs font-inter leading-normal text-center font-medium text-cool-gray-600 uppercase py-4"
              >
                Recent orders
              </h2>
              <div class="overflow-hidden rounded px-2">
                <table class="min-w-full ">
                  <thead class="bg-white-two ">
                    <tr>
                      <th
                        class="text-xs  font-inter leading-loose font-medium text-cool-gray-500 uppercase py-2"
                      >
                        Order Id
                      </th>
                      <th
                        class="text-xs font-inter leading-loose font-medium text-cool-gray-500 uppercase py-2"
                      >
                        Created at
                      </th>
                      <th
                        class="text-xs font-inter leading-loose font-medium text-cool-gray-500 uppercase py-2"
                      >
                        status
                      </th>
                      <th
                        class="text-xs font-inter leading-loose font-medium text-cool-gray-500 uppercase py-2"
                      >
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody class="text-cool-gray-500">
                    <tr v-for="(order, index) in orders" :key="index">
                      <td
                        class="text-left text-xs py-2 px-2  font-inter leading-normal "
                      >
                        <a
                          class="text-blue-500"
                          :href="order.url"
                          target="_blank"
                          >{{ order.num }}</a
                        >
                      </td>
                      <td
                        class="text-left text-xs py-2 px-2  font-inter leading-normal text-cool-gray-500"
                      >
                        {{ order.date }}
                      </td>
                      <td
                        class="text-left text-xs py-2 px-2  font-inter leading-normal text-cool-gray-500"
                      >
                        {{ order.status }}
                      </td>
                      <td
                        class="text-left text-xs py-2 px-2  font-inter leading-normal text-cool-gray-500"
                      >
                        {{ order.amount }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="mt-4 ">
              <h6
                class="text-xs font-inter leading-normal text-center font-medium text-cool-gray-600 uppercase"
              >
                Tags
              </h6>
              <span v-if="customer.tags && customer.tags.length === 0"
                >No tags</span
              >
              <div
                class="text-xs font-inter leading-normal text-cool-gray-500 px-2 py-2"
              >
                {{ customer.tags }}
              </div>
            </div>

            <div class="mt-4 ">
              <h6
                class="text-xs font-inter leading-normal text-center font-medium text-cool-gray-600 uppercase"
              >
                Note
              </h6>
              <span v-if="customer.note && customer.note.length === 0"
                >No tags</span
              >
              <div
                class="text-xs font-inter leading-normal text-cool-gray-500 px-2 py-2"
              >
                {{ customer.note }}
              </div>
            </div>
          </div>
          <div
            class="text-center mt-2 text-sm"
            v-if="!isLoading && customer && Object.keys(customer).length === 0"
          >
            Customer not found
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from "../../Mixins/helpers";

import { debounce } from "lodash-es";

export default {
  name: "InboxRightSidebar",
  mixins: [Helpers],
  props: {
    conversation: {
      type: Object
    }
  },
  data() {
    return {
      customer: {},
      contact: {},
      orders: [],
      isLoading: false,
      showSidebarOnMobile: false,
      productSearchText: "",
      products: [],
      shopDomain: ""
    };
  },
  computed: {
    tags() {
      return this.customer.tags.split(",");
    }
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.isLoading = true;
      const response = await this.$store.dispatch("Inbox/getCustomer", {
        phoneNumber: this.conversation.customer.phoneNumber
      });
      this.customer = response.result.customer;
      this.orders = response.result.orders;
      this.isLoading = false;
    },
    getFirstCharInStr(str) {
      return str.charAt(0);
    },
    getFirstCharacter() {
      return this.getFirstCharInStr(this.conversation.customer.firstName);
    },
    toggleSidebar() {
      this.showSidebarOnMobile = !this.showSidebarOnMobile;
    },
    searchProducts: debounce(function(event) {
      console.log("search text", event.target.value);
      const searchText = event.target.value;
      this.$store
        .dispatch("Inbox/searchProducts", {
          requestParams: { searchText }
        })
        .then(response => {
          this.products = response.products;
          this.shopDomain = response.shopDomain;
        });
    }, 1000),
    sendProductLinkToChat(product) {
      const url = `https://${this.shopDomain}${product.url}`;
      this.$emit("sendProductUrl", url);
      this.productSearchText = "";
      this.products = [];
    }
  }
};
</script>

<style lang="scss" scoped></style>
